// Profile
export const GET_ACCOUNT = 'GET_ACCOUNT';
export const GET_ADDRESS = 'GET_ADDRESS';
export const GET_CONTACT = 'GET_CONTACT';
export const GET_ORGANIZATION_SETTINGS = 'GET_ORGANIZATION_SETTINGS';
export const RESET_PROFILE = 'RESET_PROFILE';
export const GET_PUBLIC_PROFILE = 'GET_PUBLIC_PROFILE';

// Auth
export const CHECK_AUTHENTICATION = 'CHECK_AUTHENTICATION';
export const LOGOUT = 'LOGOUT';
export const LOGIN = 'LOGIN';
export const UPDATE_REFRESHING = 'UPDATE_REFRESHING';
export const SET_MAINTENANCE_MODE = 'SET_MAINTENANCE_MODE';
export const TWO_FACTOR_VERIFICATION = 'TWO_FACTOR_VERIFICATION';
export const CHECK_TWO_FACTOR_VERIFICATION = 'CHECK_TWO_FACTOR_VERIFICATION';

// Plan
export const FETCH_ALL_PLANS = 'FETCH_ALL_PLANS';
export const SET_CHOSEN_PLAN = 'SET_CHOSEN_PLAN';

// Organization Types
export const FETCH_ALL_ORGANIZATION_TYPES = 'FETCH_ALL_ORGANIZATION_TYPES';

// Clients
export const FETCH_CLIENTS = 'FETCH_CLIENTS';
export const RESET_CLIENTS = 'RESET_CLIENTS';
export const FETCH_ALL_CLIENTS = 'FETCH_ALL_CLIENTS';
export const FETCH_ALL_CLIENT_OPTIONS = 'FETCH_ALL_CLIENT_OPTIONS';
export const FETCH_ALL_CLIENT_TYPES = 'FETCH_ALL_CLIENT_TYPES';
export const CLIENT_QUERY = 'CLIENT_QUERY';

//  Client Address Types
export const FETCH_ADDRESS_TYPES = 'FETCH_ADDRESS_TYPES';

//  Client Contact Types
export const FETCH_CONTACT_TYPES = 'FETCH_CONTACT_TYPES';

//  Client Contacts
export const SET_CURRENT_CLIENT_CONTACTS = 'SET_CURRENT_CLIENT_CONTACTS';
export const ADD_CLIENT_CONTACT = 'ADD_CLIENT_CONTACT';
export const DELETE_CLIENT_CONTACT = 'DELETE_CLIENT_CONTACT';
export const UPDATE_CLIENT_CONTACT = 'UPDATE_CLIENT_CONTACT';

//  Client Addresses
export const SET_CURRENT_CLIENT_ADDRESSES = 'SET_CURRENT_CLIENT_ADDRESSES';
export const ADD_CLIENT_ADDRESS = 'ADD_CLIENT_ADDRESS';
export const UPDATE_CLIENT_ADDRESS = 'UPDATE_CLIENT_ADDRESS';
export const DELETE_CLIENT_ADDRESS = 'DELETE_CLIENT_ADDRESS';

// Providers
export const SELECTED_PROVIDER = 'SELECTED_PROVIDER';
export const DOWNLOAD_PROVIDER_LIST = 'DOWNLOAD_PROVIDER_LIST';
export const CLIENT_PROVIDER = 'CLIENT_PROVIDER';
export const ADD_NEW_DOWNLOAD_PROVIDER_LIST = 'ADD_NEW_DOWNLOAD_PROVIDER_LIST';

// Client Groups
export const FETCH_PAGINATED_CLIENT_GROUPS = 'FETCH_PAGINATED_CLIENT_GROUPS';
export const FETCH_ALL_CLIENT_GROUPS = 'FETCH_ALL_CLIENT_GROUPS';
export const ADD_CLIENT_GROUP = 'ADD_CLIENT_GROUP';
export const UPDATE_CLIENT_GROUP = 'UPDATE_CLIENT_GROUP';
export const RESET_CLIENT_GROUPS = 'RESET_CLIENT_GROUPS';

// Product
export const FETCH_PAGINATED_PRODUCTS = 'FETCH_PAGINATED_PRODUCTS';
export const RESET_PRODUCTS = 'RESET_PRODUCTS';
export const FETCH_ALL_PRODUCTS = 'FETCH_ALL_PRODUCTS';
export const FETCH_ALL_PRODUCTS_BASIC = 'FETCH_ALL_PRODUCTS_BASIC';
export const FETCH_ALL_PRODUCT_TRANSACTIONS = 'FETCH_ALL_PRODUCT_TRANSACTIONS';
export const FETCH_ALL_PRODUCT_TRANSACTIONSV2 = 'FETCH_ALL_PRODUCT_TRANSACTIONSV2';
export const FETCH_PRODUCT_TRANSACTIONSV2 = 'FETCH_PRODUCT_TRANSACTIONSV2';
export const ADD_PRODUCT_PRICE = 'ADD_PRODUCT_PRICE';
export const UPDATE_PRODUCT_PRICE = 'UPDATE_PRODUCT_PRICE';
export const REMOVE_PRODUCT_PRICE = 'REMOVE_PRODUCT_PRICE';
export const FETCH_PRODUCT_PRICES = 'FETCH_PRODUCT_PRICES';
export const PRODUCT_QUERY = 'PRODUCT_QUERY';
export const SET_PRODUCT_GROUPING = 'SET_PRODUCT_GROUPING';

// Product Groups
export const FETCH_PAGINATED_PRODUCT_GROUPS = 'FETCH_PAGINATED_PRODUCT_GROUPS';
export const FETCH_ALL_PRODUCT_GROUPS = 'FETCH_ALL_PRODUCT_GROUPS';
export const RESET_PRODUCT_GROUPS = 'RESET_PRODUCT_GROUPS';

// Product Packagings
export const FETCH_PAGINATED_PRODUCT_PACKAGINGS = 'FETCH_PAGINATED_PRODUCT_PACKAGINGS';
export const FETCH_ALL_PRODUCT_PACKAGINGS = 'FETCH_ALL_PRODUCT_PACKAGINGS';
export const RESET_PRODUCT_PACKAGINGS = 'RESET_PRODUCT_PACKAGINGS';
export const ADD_NULL_PRODUCT_PACKAGINGS = 'ADD_NULL_PRODUCT_PACKAGINGS';

// Packaging Materials
export const FETCH_PACKAGING_MATERIALS = 'FETCH_PACKAGING_MATERIALS';

// Unit Types
export const FETCH_UNIT_TYPES = 'FETCH_UNIT_TYPES';

// Packaging Types
export const FETCH_PACKAGING_TYPES = 'FETCH_PACKAGING_TYPES';

// Orders
export const FETCH_PAGINATED_ORDERS = 'FETCH_PAGINATED_ORDERS';
export const FETCH_ALL_ORDERS = 'FETCH_ALL_ORDERS';
export const RESET_ORDERS = 'RESET_ORDERS';
export const RESET_CURRENT_ORDER = 'RESET_CURRENT_ORDER';
export const FETCH_ORDER_TYPES = 'FETCH_ORDER_TYPES';
export const FETCH_CURRENT_ORDER = 'FETCH_CURRENT_ORDER';
export const UPDATE_CURRENT_ORDER = 'UPDATE_CURRENT_ORDER';
export const FETCH_ORDER_EVENTS = 'FETCH_ORDER_EVENTS';
export const ORDER_QUERY = 'ORDER_QUERY';

// Product Types
export const FETCH_ALL_PRODUCT_TYPES = 'FETCH_ALL_PRODUCT_TYPES';

// Product Subtypes
export const FETCH_ALL_PRODUCT_SUBTYPES = 'FETCH_ALL_PRODUCT_SUBTYPES';

// Product Recommendations
export const FETCH_ALL_PRODUCT_RECOMMENDATIONS = 'FETCH_ALL_PRODUCT_RECOMMENDATIONS';

// Producers
export const FETCH_ALL_PRODUCERS = 'FETCH_ALL_PRODUCERS';

// Product Deposits
export const FETCH_ALL_PRODUCT_DEPOSITS = 'FETCH_ALL_PRODUCT_DEPOSITS';
export const ADD_NULL_DEPOSIT_LIST = 'ADD_NULL_DEPOSIT_LIST';

// Deposit Systems
export const FETCH_ALL_DEPOSIT_SYSTEMS = 'FETCH_ALL_DEPOSIT_SYSTEMS';
export const ADD_NULL_DEPOSIT_SYSTEM = 'ADD_NULL_DEPOSIT_SYSTEM';


// Countries
export const FETCH_COUNTRIES = 'FETCH_COUNTRIES';

// Cities
export const FETCH_CITIES = 'FETCH_CITIES';

// Municipalities
export const FETCH_MUNICIPALITIES = 'FETCH_MUNICIPALITIES';

// Postals
export const FETCH_POSTALS = 'FETCH_POSTALS';

// Taxes
export const FETCH_TAXES = 'FETCH_TAXES';

// Business Days
export const FETCH_BUSINESS_DAYS = 'FETCH_BUSINESS_DAYS';

// Business Hours
export const FETCH_BUSINESS_HOURS = 'FETCH_BUSINESS_HOURS';
export const STORE_BUSINESS_HOUR = 'STORE_BUSINESS_HOUR';
export const DESTROY_BUSINESS_HOUR = 'DESTROY_BUSINESS_HOUR';

// Business Hour Exceptions
export const FETCH_BUSINESS_HOUR_EXCEPTIONS = 'FETCH_BUSINESS_HOUR_EXCEPTIONS';
export const STORE_BUSINESS_HOUR_EXCEPTION = 'STORE_BUSINESS_HOUR_EXCEPTION';
export const DESTROY_BUSINESS_HOUR_EXCEPTION = 'DESTROY_BUSINESS_HOUR_EXCEPTION';

// Bill
export const FETCH_PAGINATED_BILLS = 'FETCH_PAGINATED_BILLS';
export const RESET_BILLS = 'RESET_BILLS';
export const FETCH_BILL_STATUSES = 'FETCH_BILL_STATUSES';
export const FETCH_BILL_TYPES = 'FETCH_BILL_TYPES';
export const FETCH_CURRENT_BILL = 'FETCH_CURRENT_BILL';
export const BILL_QUERY = 'BILL_QUERY';

// Order Products
export const FETCH_ALL_ORDER_PRODUCTS = 'FETCH_ALL_ORDER_PRODUCTS';
export const REMOVE_ORDER_PRODUCT = 'REMOVE_ORDER_PRODUCT';
export const ADD_ORDER_PRODUCT = 'ADD_ORDER_PRODUCT';
export const UPDATE_ORDER_PRODUCT = 'UPDATE_ORDER_PRODUCT';
export const RESET_ORDER_PRODUCTS = 'RESET_ORDER_PRODUCTS';

// Bill Products
export const FETCH_ALL_BILL_PRODUCTS = 'FETCH_ALL_BILL_PRODUCTS';
export const REMOVE_BILL_PRODUCT = 'REMOVE_BILL_PRODUCT';
export const ADD_BILL_PRODUCT = 'ADD_BILL_PRODUCT';
export const UPDATE_BILL_PRODUCT = 'UPDATE_BILL_PRODUCT';
export const RESET_BILL_PRODUCTS = 'RESET_BILL_PRODUCTS';

// Credit Note Products
export const FETCH_ALL_CREDIT_NOTE_PRODUCTS = 'FETCH_ALL_CREDIT_NOTE_PRODUCTS';
export const REMOVE_CREDIT_NOTE_PRODUCT = 'REMOVE_CREDIT_NOTE_PRODUCT';
export const ADD_CREDIT_NOTE_PRODUCT = 'ADD_CREDIT_NOTE_PRODUCT';
export const UPDATE_CREDIT_NOTE_PRODUCT = 'UPDATE_CREDIT_NOTE_PRODUCT';
export const RESET_CREDIT_NOTE_PRODUCTS = 'RESET_CREDIT_NOTE_PRODUCTS';
export const FETCH_ALL_CREDIT_NOTE_REASONS = 'FETCH_ALL_CREDIT_NOTE_REASONS';
export const FETCH_CURRENT_CREDIT_NOTE_REASON = 'FETCH_CURRENT_CREDIT_NOTE_REASON';

// Edi Orders
export const FETCH_ALL_EDI_ORDERS = 'FETCH_ALL_EDI_ORDERS';
export const FETCH_PAGINATED_EDI_ORDERS = 'FETCH_PAGINATED_EDI_ORDERS';
export const FETCH_CURRENT_EDI_ORDER = 'FETCH_CURRENT_EDI_ORDER';
export const RESET_CURRENT_EDI_ORDER = 'RESET_CURRENT_EDI_ORDER';

// Edi Order Items
export const FETCH_ALL_EDI_ORDER_ITEMS = 'FETCH_ALL_EDI_ORDER_ITEMS';
export const UPDATE_EDI_ORDER_ITEM = 'UPDATE_EDI_ORDER_ITEM';

// Message Template Types
export const FETCH_ALL_MESSAGE_TEMPLATE_TYPES = 'FETCH_ALL_MESSAGE_TEMPLATE_TYPES';

// Accounting Providers
export const FETCH_ALL_ACCOUNTING_PROVIDERS = 'FETCH_ALL_ACCOUNTING_PROVIDERS';

// Chart Of Accounts
export const FETCH_ALL_CHART_OF_ACCOUNTS = 'FETCH_ALL_CHART_OF_ACCOUNTS';
export const UPDATE_CHART_OF_ACCOUNTS_ITEM = 'UPDATE_CHART_OF_ACCOUNTS_ITEM';
export const REMOVE_CHART_OF_ACCOUNTS_ITEM = 'REMOVE_CHART_OF_ACCOUNTS_ITEM';
export const ADD_CHART_OF_ACCOUNTS_ITEM = 'ADD_CHART_OF_ACCOUNTS_ITEM';

// Campaigns
export const FETCH_PAGINATED_CAMPAIGNS = 'FETCH_PAGINATED_CAMPAIGNS';
export const FETCH_ALL_CAMPAIGNS = 'FETCH_ALL_CAMPAIGNS';
export const RESET_CAMPAIGNS = 'RESET_CAMPAIGNS';

// Campaign Types
export const FETCH_CAMPAIGN_TYPES = 'FETCH_CAMPAIGN_TYPES';

// Sidebar
export const TOGGLE_INNERSIDEBAR = 'TOGGLE_INNERSIDEBAR';
export const SET_INNERSIDEBAR = 'SET_INNERSIDEBAR';
export const UNSET_INNERSIDEBAR = 'UNSET_INNERSIDEBAR';
export const DISABLE_INNERSIDEBAR = 'DISABLE_INNERSIDEBAR';
export const ENABLE_INNERSIDEBAR = 'ENABLE_INNERSIDEBAR';


// Modal
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const SET_MODAL_CONTENT = 'SET_MODAL_CONTENT';
export const SET_MODAL_PROPS = 'SET_MODAL_PROPS';
export const UNSET_MODAL_CONTENT = 'UNSET_MODAL_CONTENT';
export const SET_MODAL_SIZE = 'SET_MODAL_SIZE';
export const SET_MODAL_CLASS = 'SET_MODAL_CLASS';
export const SET_MODAL_CLOSE_ON_CLICK = 'SET_MODAL_CLOSE_ON_CLICK';
export const SET_MODAL_SHOW_CLOSE = 'SET_MODAL_SHOW_CLOSE';
export const SET_MODAL_CLOSE_ON_PRESS_ESCAPE = 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE';
export const SET_MODAL_BUTTON_LOADING = 'SET_MODAL_BUTTON_LOADING';
export const UPDATE_PREVIEW_PARAM = 'UPDATE_PREVIEW_PARAM';

// Supplier
export const FETCH_ALL_SUPPLIERS = 'FETCH_ALL_SUPPLIERS';
export const FETCH_PAGINATE_SUPPLIERS = 'FETCH_PAGINATE_SUPPLIERS';
export const FETCH_CURRENT_SUPPLIER = 'FETCH_CURRENT_SUPPLIER';

// Warehouse
export const FETCH_ALL_WAREHOUSES = 'FETCH_ALL_WAREHOUSES';
export const FETCH_PAGINATE_WAREHOUSES = 'FETCH_PAGINATE_WAREHOUSES';
export const FETCH_CURRENT_WAREHOUSE = 'FETCH_CURRENT_WAREHOUSE';
// export const FETCH_CURRENT_WAREHOUSE_PRODUCTS = 'FETCH_CURRENT_WAREHOUSE_PRODUCTS';
export const FETCH_PAGINATE_WAREHOUSE_PRODUCTS = 'FETCH_PAGINATE_WAREHOUSE_PRODUCTS';
export const FETCH_ALL_WAREHOUSE_TRANSACTIONS = 'FETCH_ALL_WAREHOUSE_TRANSACTIONS';

// TRANSACTIONSV2
export const FETCH_ALL_WAREHOUSE_TRANSACTIONSV2 = 'FETCH_ALL_WAREHOUSE_TRANSACTIONSV2';
export const FETCH_PAGINATE_WAREHOUSE_TRANSACTIONSV2 = 'FETCH_PAGINATE_WAREHOUSE_TRANSACTIONSV2';

// UNIT OF MEASURES
export const FETCH_ALL_UNIT_OF_MEASURES = 'FETCH_ALL_UNIT_OF_MEASURES';
export const FETCH_PAGINATE_UNIT_OF_MEASURES = 'FETCH_PAGINATE_UNIT_OF_MEASURES';
export const FETCH_CURRENT_UNIT_OF_MEASURES = 'FETCH_CURRENT_UNIT_OF_MEASURES';

// STOCKS
export const FETCH_ALL_STOCKS = 'FETCH_ALL_STOCKS';
export const FETCH_PAGINATE_STOCKS = 'FETCH_PAGINATE_STOCKS';
export const FETCH_CURRENT_STOCK = 'FETCH_CURRENT_STOCK';
export const FETCH_CURRENT_STOCK_PRODUCTS = 'FETCH_CURRENT_STOCK_PRODUCTS';
export const REFRESH_STOCK_PRODUCTS = 'REFRESH_STOCK_PRODUCTS';
export const PUSH_TO_STOCK_PRODUCTS = 'PUSH_TO_STOCK_PRODUCTS';
export const DELETE_TO_STOCK_PRODUCTS = 'DELETE_TO_STOCK_PRODUCTS';
export const EDIT_TO_STOCK_PRODUCTS = 'EDIT_TO_STOCK_PRODUCTS';
export const SET_STOCK_SELECTED_WAREHOUSE = 'SET_STOCK_SELECTED_WAREHOUSE';

export const FETCH_CURRENT_STOCK_PRODUCTS_CUSTOM = 'FETCH_CURRENT_STOCK_PRODUCTS_CUSTOM';
export const PUSH_TO_STOCK_PRODUCTS_CUSTOM = 'PUSH_TO_STOCK_PRODUCTS_CUSTOM';
export const REFRESH_STOCK_PRODUCTS_CUSTOM = 'REFRESH_STOCK_PRODUCTS_CUSTOM';
export const UPDATE_TO_STOCK_PRODUCTS = 'UPDATE_TO_STOCK_PRODUCTS';
export const DELETE_FROM_STOCK_PRODUCTS_CUSTOM = 'DELETE_FROM_STOCK_PRODUCTS_CUSTOM';
// ADJUSTMENTS
export const FETCH_ALL_ADJUSTMENTS = 'FETCH_ALL_ADJUSTMENTS';
export const FETCH_PAGINATE_ADJUSTMENTS = 'FETCH_PAGINATE_ADJUSTMENTS';
export const FETCH_CURRENT_ADJUSTMENT = 'FETCH_CURRENT_ADJUSTMENT';

// PURCHASES
export const FETCH_ALL_PURCHASES = 'FETCH_ALL_PURCHASES';
export const FETCH_PAGINATE_PURCHASES = 'FETCH_PAGINATE_PURCHASES';
export const FETCH_CURRENT_PURCHASE = 'FETCH_CURRENT_PURCHASE';
export const FETCH_PURCHASE_STATUSES = 'FETCH_PURCHASE_STATUSES';

// VIEWS
export const TYPE_OF_VIEW = 'TYPE_OF_VIEW';
export const TYPE_OF_ORDER_VIEW = 'TYPE_OF_ORDER_VIEW';

// SHIPPING PROVIDERS
export const FETCH_ALL_SHIPPING_PROVIDERS = 'FETCH_ALL_SHIPPING_PROVIDERS';
export const FETCH_CURRENT_SHIPPING_PROVIDER = 'FETCH_CURRENT_SHIPPING_PROVIDER';

// PRODUCT GROUPS
export const FETCH_PAGINATED_PRODUCT_TAGS = 'FETCH_PAGINATED_PRODUCT_TAGS';
export const FETCH_ALL_PRODUCT_TAGS = 'FETCH_ALL_PRODUCT_TAGS';
export const RESET_PRODUCT_TAGS = 'RESET_PRODUCT_TAGS';

// PRICE FIELD
export const FETCH_PAGINATED_PRICE_FIELDS = 'FETCH_PAGINATED_PRICE_FIELDS';
export const FETCH_ALL_PRICE_FIELDS = 'FETCH_ALL_PRICE_FIELDS';
export const RESET_PRICE_FIELDS = 'RESET_PRICE_FIELDS';

// PRODUCTFLOW
export const FETCH_ALL_PRODUCTFLOWS = 'FETCH_ALL_PRODUCTFLOWS';
export const FETCH_PAGINATE_PRODUCTFLOWS = 'FETCH_PAGINATE_PRODUCTFLOWS';
export const FETCH_CURRENT_PRODUCTFLOW = 'FETCH_CURRENT_PRODUCTFLOW';
export const FETCH_ALL_PRODUCTFLOW_ORDERS = 'FETCH_ALL_PRODUCTFLOW_ORDERS';

// EXCISE GROUPS
export const FETCH_EXCISE_GROUPS = 'FETCH_EXCISE_GROUPS';
export const ADD_NULL_TO_EXCISE_GROUPS_LIST = 'ADD_NULL_TO_EXCISE_GROUPS_LIST';
export const FETCH_EXCISE_PACKAGING_GROUPS = 'FETCH_EXCISE_PACKAGING_GROUPS';
export const FETCH_EXCISE_BASIC = 'FETCH_EXCISE_BASIC';

export const FETCH_ADDITIONAL_CODE = 'FETCH_ADDITIONAL_CODE';

export const FETCH_ALL_ORGANIZATION_MEMBERS = 'FETCH_ALL_ORGANIZATION_MEMBERS';
export const ADD_ORGANIZATION_MEMBER = 'ADD_ORGANIZATION_MEMBER';

export const FETCH_ALL_ORGANIZATION_MEMBER_PRODUCT_BUSINESSHOURS = 'FETCH_ALL_ORGANIZATION_MEMBER_PRODUCT_BUSINESSHOURS';
export const FETCH_ALL_ORGANIZATION_MEMBER_BOOKINGS = 'FETCH_ALL_ORGANIZATION_MEMBER_BOOKINGS';
export const ADD_ORGANIZATION_MEMBER_BOOKING = 'ADD_ORGANIZATION_MEMBER_BOOKING';

// MODULES
export const FETCH_ALL_MODULES = 'FETCH_ALL_MODULES';
// ORGANIZATION TYPES
export const FETCH_ALL_TRANSACTION_TYPES = 'FETCH_ALL_TRANSACTION_TYPES';

// TRANSFER
export const FETCH_ALL_TRANSFERS = 'FETCH_ALL_TRANSFERS';
export const FETCH_PAGINATE_TRANSFERS = 'FETCH_PAGINATE_TRANSFERS';
export const FETCH_CURRENT_TRANSFER = 'FETCH_CURRENT_TRANSFER';
export const FETCH_TRANSFER_STATUSES = 'FETCH_TRANSFER_STATUSES';

// Material
export const FETCH_PAGINATED_MATERIALS = 'FETCH_PAGINATED_MATERIALS';
export const FETCH_ALL_MATERIALS = 'FETCH_ALL_MATERIALS';
export const MATERIAL_QUERY = 'MATERIAL_QUERY';

// Material Types
export const FETCH_ALL_MATERIAL_TYPES = 'FETCH_ALL_MATERIAL_TYPES';

// Batches
export const ADD_BATCH = 'ADD_BATCH';
export const FETCH_PAGINATED_BATCHES = 'FETCH_PAGINATED_BATCHES';
export const FETCH_ALL_BATCHES = 'FETCH_ALL_BATCHES';
export const BATCH_QUERY = 'BATCH_QUERY';

// Batch Logs
export const FETCH_PAGINATED_BATCH_LOGS = 'FETCH_PAGINATED_BATCH_LOGS';
export const FETCH_ALL_BATCH_LOGS = 'FETCH_ALL_BATCH_LOGS';
export const BATCH_LOG_QUERY = 'BATCH_LOG_QUERY';

// Recipes
export const FETCH_PAGINATED_RECIPES = 'FETCH_PAGINATED_RECIPES';
export const FETCH_ALL_RECIPES = 'FETCH_ALL_RECIPES';
export const RECIPE_QUERY = 'RECIPE_QUERY';

// Recipe Types
export const FETCH_ALL_RECIPE_TYPES = 'FETCH_ALL_RECIPE_TYPES';

// Recipe Ingredience
export const FETCH_ALL_RECIPE_INGREDIENCES = 'FETCH_ALL_RECIPE_INGREDIENCES';
export const REMOVE_RECIPE_INGREDIENCE = 'REMOVE_RECIPE_INGREDIENCE';
export const ADD_RECIPE_INGREDIENCE = 'ADD_RECIPE_INGREDIENCE';
export const UPDATE_RECIPE_INGREDIENCE = 'UPDATE_RECIPE_INGREDIENCE';
export const RESET_RECIPE_INGREDIENCES = 'RESET_RECIPE_INGREDIENCES';

// Batch Ingredience
export const FETCH_ALL_BATCH_INGREDIENCES = 'FETCH_ALL_BATCH_INGREDIENCES';
export const REMOVE_BATCH_INGREDIENCE = 'REMOVE_BATCH_INGREDIENCE';
export const ADD_BATCH_INGREDIENCE = 'ADD_BATCH_INGREDIENCE';
export const UPDATE_BATCH_INGREDIENCE = 'UPDATE_BATCH_INGREDIENCE';
export const RESET_BATCH_INGREDIENCES = 'RESET_BATCH_INGREDIENCES';

// Recipe Procedure
export const FETCH_ALL_RECIPE_PROCEDURES = 'FETCH_ALL_RECIPE_PROCEDURES';
export const REMOVE_RECIPE_PROCEDURE = 'REMOVE_RECIPE_PROCEDURE';
export const ADD_RECIPE_PROCEDURE = 'ADD_RECIPE_PROCEDURE';
export const UPDATE_RECIPE_PROCEDURE = 'UPDATE_RECIPE_PROCEDURE';
export const RESET_RECIPE_PROCEDURES = 'RESET_RECIPE_PROCEDURES';

// Recipe Product
export const FETCH_ALL_RECIPE_PRODUCTS = 'FETCH_ALL_RECIPE_PRODUCTS';
export const REMOVE_RECIPE_PRODUCT = 'REMOVE_RECIPE_PRODUCT';
export const ADD_RECIPE_PRODUCT = 'ADD_RECIPE_PRODUCT';
export const RESET_RECIPE_PRODUCTS = 'RESET_RECIPE_PRODUCTS';

// Equipments
export const FETCH_PAGINATED_EQUIPMENTS = 'FETCH_PAGINATED_EQUIPMENTS';
export const FETCH_ALL_EQUIPMENTS = 'FETCH_ALL_EQUIPMENTS';
export const EQUIPMENT_QUERY = 'EQUIPMENT_QUERY';

// SITE LANGUAGES
export const FETCH_SITELANGUAGES = 'FETCH_SITELANGUAGES';

// User widgets
export const FETCH_AVAILABLE_WIDGETS = 'FETCH_AVAILABLE_WIDGETS';
export const FETCH_USER_WIDGETS = 'FETCH_USER_WIDGETS';
export const FETCH_BEST_CLIENTS_WIDGETS = 'FETCH_BEST_CLIENTS_WIDGETS';
export const FETCH_WAITING_PROCESSED_WIDGETS = 'FETCH_WAITING_PROCESSED_WIDGETS';
export const FETCH_WAITING_DELIVERED_WIDGETS = 'FETCH_WAITING_DELIVERED_WIDGETS';
export const FETCH_ORDER_RECEIVED_WIDGETS = 'FETCH_ORDER_RECEIVED_WIDGETS';
export const FETCH_REVENUE_WIDGETS = 'FETCH_REVENUE_WIDGETS';
export const FETCH_POPULAR_PRODUCTS_WIDGETS = 'FETCH_POPULAR_PRODUCTS_WIDGETS';
export const FETCH_SOLD_PRODUCTS_WIDGETS = 'FETCH_SOLD_PRODUCTS_WIDGETS';

// EXCISE PERIODS
export const FETCH_PAGINATED_EXCISE_PERIODS = 'FETCH_PAGINATED_EXCISE_PERIODS';
export const FETCH_ALL_EXCISE_PERIODS = 'FETCH_ALL_EXCISE_PERIODS';

// SUBSCRIBER LIST
export const FETCH_PAGINATED_SUBSCRIBER_LIST = 'FETCH_PAGINATED_SUBSCRIBER_LIST';
export const FETCH_ALL_SUBSCRIBER_LIST = 'FETCH_ALL_SUBSCRIBELIST_LIST';
export const FETCH_CURRENT_SUBSCRIBER_LIST = 'FETCH_CURRENT_SUBSCRIBER_LIST';
export const SET_MODIFIED_CLIENT_GROUP = 'SET_MODIFIED_CLIENT_GROUP';
export const SET_CANCEL_CLIENT_GROUP_ADD = 'SET_CANCEL_CLIENT_GROUP_ADD';

// SUBSCRIBER
export const FETCH_ALL_SUBSCRIBER = 'FETCH_ALL_SUBSCRIBER';
export const FETCH_PAGINATED_SUBSCRIBER = 'FETCH_PAGINATED_SUBSCRIBER';
// PACKAGE UNIT TYPES
export const FETCH_ALL_PACKAGE_UNIT_TYPES = 'FETCH_ALL_PACKAGE_UNIT_TYPES';

// PACKAGES
export const FETCH_ALL_PACKAGES = 'FETCH_ALL_PACKAGES';

// PACKAGES ORDER PRODUCTS
export const FETCH_ALL_PACKAGE_ORDER_PRODUCTS = 'FETCH_ALL_PACKAGE_ORDER_PRODUCTS';

// User app version
export const FETCH_USER_APP_VERSION = 'FETCH_USER_APP_VERSION';

// User toast if click
export const FETCH_USER_APP_TOAST = 'FETCH_USER_APP_TOAST';

// Partners
export const FETCH_ALL_PARTNERS = 'FETCH_ALL_PARTNERS';

// Order pickups
export const FETCH_PAGINATED_ORDER_PICKUPS = 'FETCH_PAGINATED_ORDER_PICKUPS';
export const FETCH_ALL_ORDER_PICKUPS = 'FETCH_ALL_ORDER_PICKUPS';
export const RESET_ORDER_PICKUPS = 'RESET_ORDER_PICKUPS';
export const RESET_CURRENT_ORDER_PICKUP = 'RESET_CURRENT_ORDER_PICKUP';
export const FETCH_ORDER_PICKUPS_TYPES = 'FETCH_ORDER_PICKUPS_TYPES';
export const FETCH_CURRENT_ORDER_PICKUP = 'FETCH_CURRENT_ORDER_PICKUP';
export const FETCH_ORDER_PICKUPS_EVENTS = 'FETCH_ORDER_PICKUPS_EVENTS';
export const ORDER_PICKUPS_QUERY = 'ORDER_PICKUPS_QUERY';

// License
export const FETCH_ALL_LICENSES = 'FETCH_ALL_LICENSES';
export const FETCH_ALL_LICENSE_TYPES = 'FETCH_ALL_LICENSE_TYPES';
export const ADD_NULL_LICENSE_TYPE = 'ADD_NULL_LICENSE_TYPE';
export const FETCH_ALL_LICENSE_PERMIT_TYPES = 'FETCH_ALL_LICENSE_PERMIT_TYPES';
export const FETCH_ALL_LICENSE_PERMITS = 'FETCH_ALL_LICENSE_PERMITS';
export const FETCH_ALL_LICENSE_GROUPS = 'FETCH_ALL_LICENSE_GROUPS';
export const FETCH_ALL_LICENSE_PERMIT_GROUPS = 'FETCH_ALL_LICENSE_PERMIT_GROUPS';

// Payment methods
export const FETCH_PAYMENT_METHODS = 'FETCH_PAYMENT_METHODS';

// Language
export const FETCH_LANGUAGES = 'FETCH_LANGUAGES';

// Currency
export const FETCH_CURRENCIES = 'FETCH_CURRENCIES';

// Project
export const FETCH_PROJECTS = 'FETCH_PROJECTS';
export const RESET_PROJECTS = 'RESET_PROJECTS';
export const FETCH_ALL_PROJECTS = 'FETCH_ALL_PROJECTS';

// Inventory bridge handoff (Phase E/F)
export const SET_BRIDGE_HANDOFF = 'SET_BRIDGE_HANDOFF';



// WEBPACK FOOTER //
// ./src/app/store/mutation-types.js